import React from "react";

// Geometric vector marks inspired by the exhibition poster (dot grid, bars, =, +, −)
const CRIMSON = "#b02418";

export const DotGrid = ({ className = "", color = CRIMSON, cols = 5, rows = 4, gap = 9, r = 1.8 }) => {
  const w = (cols - 1) * gap + r * 2;
  const h = (rows - 1) * gap + r * 2;
  const dots = [];
  for (let y = 0; y < rows; y++)
    for (let x = 0; x < cols; x++)
      dots.push(<circle key={`${x}-${y}`} cx={r + x * gap} cy={r + y * gap} r={r} />);
  return (
    <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} className={className} fill={color} aria-hidden="true">
      {dots}
    </svg>
  );
};

export const BarsMark = ({ className = "", color = CRIMSON, count = 4, w = 46, bh = 4, gap = 8 }) => {
  const bars = [];
  for (let i = 0; i < count; i++) bars.push(<rect key={i} x="0" y={i * (bh + gap)} width={w} height={bh} rx="1" />);
  const h = count * (bh + gap) - gap;
  return (
    <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`} className={className} fill={color} aria-hidden="true">
      {bars}
    </svg>
  );
};

export const EqualMark = ({ className = "", color = CRIMSON, w = 40 }) => (
  <svg width={w} height="16" viewBox={`0 0 ${w} 16`} className={className} fill={color} aria-hidden="true">
    <rect x="0" y="2" width={w} height="4" rx="1" />
    <rect x="0" y="10" width={w} height="4" rx="1" />
  </svg>
);

export const PlusMinus = ({ className = "", color = CRIMSON }) => (
  <svg width="44" height="18" viewBox="0 0 44 18" className={className} fill={color} aria-hidden="true">
    <rect x="0" y="7" width="16" height="4" rx="1" />
    <rect x="28" y="7" width="16" height="4" rx="1" />
    <rect x="34" y="1" width="4" height="16" rx="1" />
  </svg>
);

export const PlusMinusPlus = ({ className = "", color = CRIMSON }) => (
  <svg width="64" height="18" viewBox="0 0 64 18" className={className} fill={color} aria-hidden="true">
    {/* + */}
    <rect x="0" y="7" width="16" height="4" rx="1" />
    <rect x="6" y="1" width="4" height="16" rx="1" />
    {/* − */}
    <rect x="24" y="7" width="16" height="4" rx="1" />
    {/* + */}
    <rect x="48" y="7" width="16" height="4" rx="1" />
    <rect x="54" y="1" width="4" height="16" rx="1" />
  </svg>
);
